module.exports = __webpack_public_path__ + "img/Tim Melson.26ccc7b6.jpg";